
export class TransectMesure {
    DistanceRive: number;
    Profondeur: number;

    static mapFromJSON(json): TransectMesure {
        const t = new TransectMesure();

        t.DistanceRive = json.distanceRive;
        t.Profondeur = json.profondeur;

        return t;
    }
}